import { render, staticRenderFns } from "./me.vue?vue&type=template&id=4faa5536&scoped=true"
import script from "./me.vue?vue&type=script&lang=js"
export * from "./me.vue?vue&type=script&lang=js"
import style0 from "./me.vue?vue&type=style&index=0&id=4faa5536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faa5536",
  null
  
)

export default component.exports